import swalLanguage from '../locals/en/sweetalert.json';
export default (message = swalLanguage.success_action) => {
  One.helpers('notify', {
    type: 'success',
    icon: 'fa fa-check mr-1',
    message,
  });
};
